import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

declare const __BUILD_TIME__: string
;(window as unknown as Record<string, string>).__buildTime = __BUILD_TIME__

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
